export class IntraArticularAdditionalInfoA {
  static left_Fore = "LF";
  static right_fore = "RF";
  static left_hind = "LH";
  static right_hind = "RH";
}

export class IntraArticularAdditionalInfoB {
  static fetlock = "fetlock";
  static carpus = "carpus";
  static hock = "hock";
  static stifle = "stifle";
  static other = "other";
}

export class AUSIntraArticularAdditionalInfo {
  static limb = "Limb";
  static joint = "Joint";
}

export class AusIntraArticularAdditionalInfoA {
  static right_fore = "RF (Off Fore)";
  static left_Fore = "LF (Near Fore)";
  static right_hind = "RH (Off Hind)";
  static left_hind = "LH (Near Hind)";
  static rf_lf = "RF & LF (both fore limbs)"
  static rh_lh = "LH & RH (both hind limbs)"
}

export class AusIntraArticularAdditionalInfoB {
  static coffin_joint = "Coffin Joint";
  static pastern_joint = "Pastern Joint";
  static fetlock_joint = "Fetlock Joint";
  static knee = "Knee";
  static hock = "Hock";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/intra-articular-info-types.ts